import type {SavedReply} from '@github-ui/markdown-editor'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

import {useCachedRequest} from '../util/use-cached-request'
import type {ApiMarkdownSubject, SavedRepliesContext} from './types'

interface SettingsSavedReply {
  id: number
  title: string
  body: string
  default: boolean
}

async function tryGetSavedReplies(savedRepliesContext?: SavedRepliesContext): Promise<SavedReply[]> {
  try {
    const response = await verifiedFetchJSON(
      `/settings/replies${savedRepliesContext ? `?context=${savedRepliesContext}` : ''}`,
    )
    const replies = (await response.json()) as SettingsSavedReply[]
    return replies.map(reply => ({
      name: reply.title,
      content: reply.body,
    }))
  } catch {
    return []
  }
}

export function useGetSavedReplies({subjectType}: Partial<ApiMarkdownSubject>) {
  const request = useCallback(() => {
    const savedRepliesContext = subjectType === 'issue' || subjectType === 'pull_request' ? subjectType : undefined

    return tryGetSavedReplies(savedRepliesContext)
  }, [subjectType])

  return useCachedRequest(request)
}
